import loaderEfficiency from 'sagas/dashboard/ops/loaderEfficiency';
import { all } from 'redux-saga/effects';
import summary from 'sagas/dashboard/ops/summary';
import visitDurationBreakdown from 'sagas/dashboard/ops/visitDurationBreakdown';

export default function* location() {
  yield all([summary(), visitDurationBreakdown(), loaderEfficiency()]);
}
